import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-02/lesson-13/task-01";

const task: Slide = {
  titleHtml: "HRTF is affected by direction dependant and direction independent parameters.",
  description: "Drag and drop each of the parameters in the correct boxes.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
